import React, { useContext } from 'react';
import { UserContext } from '../auth/UserContext';
import { PROFILES } from '../nav/apps';
export default () => {
    const { application, organizationAccountDetails } = useContext(UserContext);
    const isProfileApplication = PROFILES.home === application.home;
    return isProfileApplication || organizationAccountDetails?.aiSettings?.aiEnabled;
};
